import React from 'react';
import { Link } from 'react-router-dom';

export default function ProjectCard({ project }) {
  // Import the image dynamically
  const getImage = (imageName) => {
    try {
      return require(`../../assets/images/${imageName}`);
    } catch (err) {
      return null;
    }
  };

  return (
    <div className="group cursor-pointer border-b border-gray-200 pb-16 hover:border-gray-400 transition-colors">
  <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8 md:gap-12">
    
    <div className="flex-1">
      <div className="text-sm uppercase tracking-wider text-gray-400 mb-4">
        Exhibit
      </div>
      <h3 className="text-4xl md:text-5xl font-light mb-4 leading-tight">
        {project.title}
      </h3>
      <p className="text-xl text-gray-600 font-light mb-6 leading-relaxed">
        {project.description}
      </p>
      <Link
        to={project.link}
        className="text-sm px-6 py-3 border border-gray-300 rounded-full hover:bg-gray-50 transition-colors inline-block"
      >
        See more
      </Link>
    </div>

    <div className="w-full md:w-96 h-64 bg-gray-100 rounded overflow-hidden">
      {project.image ? (
        <img 
          src={getImage(project.image)} 
          alt={project.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      ) : (
        <div className="w-full h-full flex items-center justify-center text-gray-400 text-sm">
          [Project Image]
        </div>
      )}
    </div>

  </div>
</div>
  );
}